import { FC } from 'react'
import { useSelector } from 'react-redux'
import { SideBar } from '../../sidebar/SideBar'
import { appsListSlice } from '../AppsList/appsListSlice'
import { AppsList } from '../AppsList'
import { cn } from '@wellesley/ui'

interface SideBarAppsListProps {
  isVisible?: boolean
}

export const SideBarAppsList: FC<SideBarAppsListProps> = ({
  isVisible = true,
}) => {
  const list = useSelector(appsListSlice.selectors.selectList)

  if (!list) return null

  return (
    <div
      className={cn(
        'overflow-hidden transition-all duration-300 ease-in-out',
        isVisible ? 'w-auto opacity-100' : 'w-0 opacity-0',
      )}
    >
      <SideBar>{(size) => <AppsList size={size} />}</SideBar>
    </div>
  )
}
